import { TGamesGridLayoutSize } from 'js/hooks/games/types';

export const getTailWidth = (
    carouselTileSize: TGamesGridLayoutSize, numeration: boolean
): number => numeration
    ? carouselTileSize === 'landscape' ? 15 : 10
    : carouselTileSize === 'landscape' ? 10 : 5;
